import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useTabsContext } from "./auth-service-tools412.js";
import classes from "./auth-service-tools416.js";
const defaultProps = {};
const TabsList = factory((_props, ref) => {
  const props = useProps("TabsList", defaultProps, _props);
  const {
    children,
    className,
    grow,
    justify,
    classNames,
    styles,
    style,
    mod,
    ...others
  } = props;
  const ctx = useTabsContext();
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...others,
    ...ctx.getStyles("list", {
      className,
      style,
      classNames,
      styles,
      props,
      variant: ctx.variant
    }),
    ref,
    role: "tablist",
    variant: ctx.variant,
    mod: [{
      grow,
      orientation: ctx.orientation,
      placement: ctx.orientation === "vertical" && ctx.placement,
      inverted: ctx.inverted
    }, mod],
    "aria-orientation": ctx.orientation,
    __vars: {
      "--tabs-justify": justify
    },
    children
  });
});
TabsList.classes = classes;
TabsList.displayName = "@mantine/core/TabsList";
export { TabsList };